import { useEffect, useState } from "react";
import { AssetDescriptionProps } from "./AssetModelTreeView";
import { Box } from "@mui/material";
import { GLTFResult } from "../../api/threed";

export function AssetAnimations({ asset, model }: AssetDescriptionProps) {
  const [selectedAnimation, setSelectedAnimation] = useState<string | null>(null);
  const [animations, setAnimations] = useState<string[]>([]);

  useEffect(() => {
    if (model && model.userData.gltf) {
      const gltf = model.userData.gltf as GLTFResult;
      setAnimations(gltf.animations.map((anim) => anim.name));
    }
  }, [model]);

  const handleAnimationSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedAnimation(event.target.value);
  };

  return (
    <Box>
      <h3>Animations</h3>
      <select value={selectedAnimation || ''} onChange={handleAnimationSelect}>
        <option value="">Select Animation</option>
        {animations.map((anim) => (
          <option key={anim} value={anim}>{anim}</option>
        ))}
      </select>
      {selectedAnimation && (
        <Box mt={2}>
          <p>Selected Animation: {selectedAnimation}</p>
          {/* Additional controls for the selected animation can be added here */}
        </Box>
      )}
    </Box>
  );
}